// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DJAVG73aooRWXUBFeJZc{flex-direction:column;gap:24px;display:flex}.xWdZ1OhV2SMOT149tWUT{flex-direction:column;gap:4px;margin-bottom:20px;display:flex}.ljiv8xuenr49nZT_fmTI{flex-direction:column;align-items:flex-start;gap:12px;display:flex}.ljiv8xuenr49nZT_fmTI .RwmpXHW5kacdDGX6ApxO{flex-direction:column;gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `DJAVG73aooRWXUBFeJZc`,
	"header": `xWdZ1OhV2SMOT149tWUT`,
	"brunchContent": `ljiv8xuenr49nZT_fmTI`,
	"brunches": `RwmpXHW5kacdDGX6ApxO`
};
export default ___CSS_LOADER_EXPORT___;
